import React from 'react';
import OfferOverlayOrClickLinkWrap from 'core/modules/OfferOverlayOrClickLinkWrap/OfferOverlayOrClickLinkWrap';
import OfferContent from '../OfferContent/OfferContent';
import './FeaturedOffer150x150.scss';

function FeaturedOffer150x150({ dataItem, sectionId }) {
  const {
    assets: { _150x150 },
    offerTitle,
    merchant: { name },
  } = dataItem;

  return (
    <div
      className="mn_featuredOffer150x150"
      data-test="featured-offer-150x150"
      data-section-type="150x150 text offer"
      data-merchant-name={name}
    >
      <OfferOverlayOrClickLinkWrap
        dataItem={dataItem}
        sectionId={sectionId}
        className="mn_featuredOffer150x150LinkOrOverlayWrap"
      >
        <img className="mn_featureOfferImage" src={_150x150} alt={offerTitle} />
        <OfferContent dataItem={dataItem} />
      </OfferOverlayOrClickLinkWrap>
    </div>
  );
}

export default FeaturedOffer150x150;
